import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'border-border bg-bg-elevated text-fg placeholder:text-fg-subtle focus-visible:border-brand-500 focus-visible:ring-ring/40 h-[var(--control-h)] w-full rounded-md border px-3 text-sm transition-[border-color,box-shadow] duration-150 focus-visible:ring-2 focus-visible:outline-none disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
